import { css, cx } from '@emotion/css';
import { TweenMax, TimelineMax } from 'gsap';
import { ReactNode, useEffect, useRef } from 'react';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';

interface WordsSplitProps {
    children: ReactNode;
    scrollRatio?: number;
    enterDelayRatio?: number;
    leaveAdvanceRatio?: number;
}
/**
 * 显示隐藏滚动动画组件
 * @props children - -react组件
 * @props enterDelayRatio - -进入延时触发倍数(默认0倍,children高度*n)
 * @props leaveAdvanceRatio - -离开提前触发倍数(默认0倍,children高度*n)
 * @props scrollRatio - -滚动距离的倍数， 默认children的高度
 * @returns
 */
export default function ScrollOpacity({ children, scrollRatio = 1, enterDelayRatio = 0, leaveAdvanceRatio = 0 }: WordsSplitProps) {
    const scrollBoxElem = useRef<HTMLDivElement>(null);

    useEffect(() => {
        let controller: any;
        let sceneIn: any;
        let sceneOut: any;
        const timeLines: any[] = [];

        if (typeof window !== 'undefined') {
            (async () => {
                const ScrollMagic = (await import('scrollmagic')).default;
                ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
                const { clientHeight = 50 } = scrollBoxElem.current || {};

                controller = new ScrollMagic.Controller();

                const scrollHeight = clientHeight * scrollRatio;

                sceneIn = createAn({
                    offset: 0 + clientHeight * enterDelayRatio,
                    triggerHook: 'onEnter',
                    duration: scrollHeight,
                    // from: { opacity: 0, ease: 'ease-out' },
                    to: {
                        opacity: 1,
                        ease: 'ease-out',
                    },
                });

                sceneOut = createAn({
                    offset: -clientHeight * (leaveAdvanceRatio + 1),
                    triggerHook: 'onLeave',
                    duration: scrollHeight,
                    to: { opacity: 0, ease: 'ease-in' },
                });

                function createAn({ triggerHook, offset, duration, from, to }: any) {
                    const scene = new ScrollMagic.Scene({
                        triggerElement: scrollBoxElem.current, //触发元素
                        offset,
                        triggerHook,
                        duration,
                    });

                    const animation = new TimelineMax();

                    const ft = from && to ? TweenMax.fromTo(scrollBoxElem.current as any, 3, from, to) : TweenMax.to(scrollBoxElem.current as any, 3, to);
                    animation.add(ft);
                    timeLines.push(animation);
                    scene.setTween(animation);
                    return scene;
                }

                controller.addScene(sceneIn).addScene(sceneOut);
            })();
        }

        return () => {
            timeLines.forEach((i) => i && i.kill());
            sceneIn && sceneIn.destroy();
            controller && controller.destroy();
        };
    }, []);

    return (
        <div
            className={cx(
                'ScrollOpacity',
                css`
                    // transition-delay: 0.5s;
                    opacity: 0;
                `,
            )}
            ref={scrollBoxElem}
        >
            {children}
        </div>
    );
}
